module.exports = __webpack_public_path__ + "static/media/neighbourhood-2.c0049f71.jpg";